// Formatting shared by the transaction list, the transaction detail and its request/response bodies.

export function statusBadge(value: string): string {
  switch (value) {
    case "Succeeded":
      return "bg-success";
    case "SucceededWithWarning":
    case "Warning":
      return "bg-warning";
    case "Failed":
      return "bg-danger";
    default:
      return "bg-secondary";
  }
}

/** The engine's own name for an outcome, said the way the count chips say it. */
export function statusLabel(value: string): string {
  if (value === "NeverResponded") return "In doubt";
  if (value === "SucceededWithWarning") return "Warning";
  return value;
}

export function statusCodeBadge(code: number | null | undefined): string {
  if (!code) return "bg-secondary";
  if (code < 300) return "bg-success";
  if (code < 400) return "bg-info";
  if (code < 500) return "bg-warning";
  return "bg-danger";
}

/** A duration in milliseconds, as "640 ms" under a second, "3.2 s" under a minute and "4.5 min" from there. */
export function formatMs(ms: number): string {
  const wholeMs = Math.round(ms);
  if (wholeMs < 1000) return `${wholeMs} ms`;
  const seconds = ms / 1000;
  if (seconds < 60) return `${seconds.toFixed(1)} s`;
  const minutes = seconds / 60;
  return `${minutes.toFixed(1)} min`;
}

/** The time between two instants, or nothing when the second never happened. */
export function elapsed(from: Date | string, to: Date | string | null | undefined): string {
  if (!to) return "";
  const ms = new Date(to).getTime() - new Date(from).getTime();
  return formatMs(ms);
}

/** An instant in the viewer's local time, as "2026-09-29 10:47:42". Empty when the value is not a date. */
export function formatTimestamp(value: Date | string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  const day = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  const time = `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  return `${day} ${time}`;
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
